import { useEffect } from 'react';

import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

import useEffectOnce from 'hooks/use-effect-once';
import { ApiKeys, Service, getApiKey } from 'utils/environment';

export default function useGoogleAnalytics() {
  const location = useLocation();
  const googleAnalytics: string = getApiKey(
    'googleAnalytics',
    ApiKeys.get(Service.googleAnalytics)
  );

  useEffectOnce(() => {
    if (googleAnalytics) {
      ReactGA.initialize(googleAnalytics);
    }
  });

  useEffect(() => {
    if (googleAnalytics) {
      const currentPath = location.pathname + location.search;
      ReactGA.set({ page: currentPath });
      ReactGA.pageview(currentPath);
    }
  }, [location, googleAnalytics]);
}
